@if (!((store.value$ | async)?.error)) {
  <div class="reconciliation-sync-page">
    <div class="row">
      <div class="col-12">
        <div class="mat-h3">Reconciliation</div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="date-filter">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" [formControl]="formControlStartDate" 
                 [readonly]="loader.tableLoading.inProgress$ | async">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="date-filter">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" [formControl]="formControlEndDate"
                 [readonly]="loader.tableLoading.inProgress$ | async">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        @if (loader.tableLoading.inProgress$ | async) {
          <custom-content-loader type="list"></custom-content-loader>
        }
        <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async), 'table-section': true, 'pb-3': true}">
          <table mat-table [dataSource]="dataSource" class="width-100 mb-2" multiTemplateDataRows>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{moment(element.date, 'YYYYMMDD').format('DD/MM/YYYY')}}</td>
            </ng-container>
            
            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef>File Name</th>
              <td mat-cell *matCellDef="let element" class="td-width ellipsis" 
                  [matTooltip]="element.fileName || '-'" 
                  [matTooltipDisabled]="!element.fileName || element.fileName.length <= 20">
                {{element.fileName || '-'}}
              </td>
            </ng-container>
            
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element" [ngClass]="getStatusClass(element.status)">
                {{element.status}}
              </td>
            </ng-container>
            
            <ng-container matColumnDef="error">
              <th mat-header-cell *matHeaderCellDef>Error</th>
              <td mat-cell *matCellDef="let element" class="td-width ellipsis error-cell">
                <div class="error-content">
                  <span [matTooltip]="element.error || '-'" 
                        [matTooltipDisabled]="!element.error || element.error.length <= 30">
                    {{element.error || '-'}}
                  </span>
                  @if (element.error) {
                    <button mat-icon-button 
                            class="copy-button" 
                            [cdkCopyToClipboard]="element.error"
                            (cdkCopyToClipboardCopied)="copyErrorToClipboard(element.error, $event)"
                            matTooltip="Copy error to clipboard">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  }
                </div>
              </td>
            </ng-container>
            
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Last Run</th>
              <td mat-cell *matCellDef="let element">{{element.timestamp ? moment(element.timestamp).format('DD/MM/YYYY HH:mm:ss') : '-'}}</td>
            </ng-container>
            
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <div class="action-buttons">
                  @if (element.status !== 'Successful') {
                    <button mat-raised-button color="primary" (click)="triggerSync(element)" class="action-button">
                      Start
                    </button>
                  } @else {
                    <button mat-icon-button color="primary" (click)="downloadFile(element)" 
                            matTooltip="Download file" class="action-button">
                      <mat-icon>download</mat-icon>
                    </button>
                  }
                </div>
              </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let element; columns: displayColumns"></tr>
          </table>
          
          @if (total) {
            <app-custom-paginator 
              [length]="total" 
              [pageIndex]="offset / limit" 
              [pageSize]="limit" 
              [pageSizeOptions]="[10, 20, 25, 50, 100]"
              (page)="onPagination($event)">
            </app-custom-paginator>
          }
        </div>
      </div>
    </div>
  </div>
} 